/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import React, { useContext } from 'react'

const ReferrerContext = React.createContext<string | undefined>(undefined)

export const ReferrerProvider = ReferrerContext.Provider

export const useReferrer = () => {
  return useContext(ReferrerContext)
}
